/**
 * 用户管理模块路由配置
 */
import type { RouteRecordRaw } from 'vue-router'
import { PermissionCode } from '@/constants/permission-codes'
import { UserManagement } from '@/modules/user/views'
import { PersonalInfo } from '@/modules/user/views/profile'

const userRoutes: RouteRecordRaw[] = [
  // 用户管理（系统管理下）
  {
    path: 'user',
    name: 'UserManagement',
    component: UserManagement,
    meta: {
      title: '用户管理',
      requiresAuth: true,
      permissions: [PermissionCode.SYSTEM_USER],
      breadcrumb: true
    }
  },
  // 个人信息（壳层，仅需登录）
  {
    path: 'info',
    name: 'PersonalInfo',
    component: PersonalInfo,
    meta: {
      titleKey: 'menu.personalInfo',
      title: '个人信息',
      requiresAuth: true,
      breadcrumb: true
    }
  }
]

export default userRoutes

